/* istanbul ignore file */
import { configureStore } from '@reduxjs/toolkit';
import { regionSlice } from './regionSlice';
import { geographicAreaSlice } from './geographicAreaSlice';
import { weatherStationSlice } from './weatherStationSlice';
import { graphViewPageSlice } from './graphViewPageSlice';
import { graphPresetSlice } from './graphPresetSlice';
import { observationsSlice } from './observationDataSlice';
import { dataTablePageSlice } from './dataTablePageSlice';
import { usersSlice } from './usersSlice';
import { dashboardViewPageSlice } from './dashboardViewPageSlice';
import { errorDialogSlice } from './errorDialogSlice';
import { avalancheDashboardViewPageSlice } from './avalancheDashboardViewPageSlice';
import { cameraViewsSlice } from './cameraViewsSlice';
import { sensorEquipmentPacketSlice } from './sensorEquipmentPacketSlice';
import { sensorEquipmentSlice } from './sensorEquipmentSlice';
import { sensorModelSlice } from './sensorModelSlice';
import { dropdownsSlice } from './dropdownsSlice';
import { dataVisualizationSlice } from './dataVisualizationSlice';
import { placementTemplatePacketSlice } from './placementTemplatePacketSlice';
import { weatherStationStatusesSlice } from './weatherStationStatusesSlice';
import { observationTypeStatusesSlice } from './observationTypeStatusesSlice';
import { avalancheSlice } from './avalancheSlice';
import { eventSlice } from './eventSlice';
import { hazardForecastSlice } from './hazardForecastSlice';
import { manualDataValidationSlice } from './manualDataValidationSlice';
import { systemNotificationsSlice } from './systemNotificationsSlice';
import { fullScreenSlice, headerSlice } from './fullScreenSlice';
import { userPresetSlice } from './userPresetSlice';
import { variableMessageSignSlice } from './variableMessageSignSlice';
import { soilTypesSlice } from './soilTypesSlice';

const store = configureStore({
  reducer: {
    users: usersSlice.reducer,
    weatherStations: weatherStationSlice.reducer,
    regions: regionSlice.reducer,
    geoRegions: geographicAreaSlice.reducer,
    graphViewPage: graphViewPageSlice.reducer,
    graphPreset: graphPresetSlice.reducer,
    observations: observationsSlice.reducer,
    dataTablePage: dataTablePageSlice.reducer,
    weatherStation: weatherStationSlice.reducer,
    cameraViews: cameraViewsSlice.reducer,
    sensorEquipmentPacket: sensorEquipmentPacketSlice.reducer,
    sensorEquipment: sensorEquipmentSlice.reducer,
    sensorModel: sensorModelSlice.reducer,
    dashboardViewPage: dashboardViewPageSlice.reducer,
    dropdowns: dropdownsSlice.reducer,
    errorDialog: errorDialogSlice.reducer,
    dataVisualization: dataVisualizationSlice.reducer,
    placementTemplatePacket: placementTemplatePacketSlice.reducer,
    weatherStationStatuses: weatherStationStatusesSlice.reducer,
    observationTypeStatuses: observationTypeStatusesSlice.reducer,
    avalanche: avalancheSlice.reducer,
    event: eventSlice.reducer,
    avalancheDashboardViewPage: avalancheDashboardViewPageSlice.reducer,
    hazardForecast: hazardForecastSlice.reducer,
    manualDataValidation: manualDataValidationSlice.reducer,
    systemNotifications: systemNotificationsSlice.reducer,
    fullScreen: fullScreenSlice.reducer,
    userPreset: userPresetSlice.reducer,
    variableMessageSign: variableMessageSignSlice.reducer,
    soilTypes: soilTypesSlice.reducer,
  },
});

export default store;
